import { Component, ViewChild } from '@angular/core';
import { WorkingTimeSchemaService } from '../working-time-schema.service';
import { Observable, Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { getNonWorkingDays } from '../store/selectors/calendars.selectors';
import { GetUserCalendar, AddWorkingTimeSchema, DeleteWorkingTimeSchemaRange, ModifyWorkingTimeSchema } from '../store/actions/calendars.actions';
import {CalendarsOperations} from '../store/reducers/calendars-operation';
import * as moment from 'moment';
import { IAppState } from 'app/IAppState';
import { IFilterColumn } from 'app/scheduler/jobs/IFilterColumn';

@Component({
  selector: 'working-time-schema-days',
  templateUrl: 'working-time-schema-days.component.html',
  styleUrls: ['working-time-schema-days.component.scss']
})

export class WorkingTimeSchemaDaysComponent {

  constructor(private _store: Store<IAppState>) {
    this.nonWorkingDays$ = this._store.pipe(select(getNonWorkingDays));
  }

  public nonWorkingDays$: Observable<IWorkingTimeSchema[]>;
  public selectedSchemaRange: IWorkingTimeSchema;
  public currentDateType: string;
  public startDate: Date = new Date();
  public finishDate: Date = new Date();
  public onDate: Date = new Date();

  @ViewChild('daysForm', { static: false}) daysForm: NgForm;

  public columns: Array<IFilterColumn> = [
    { key: 'fromDate', value: 'WORKING_TIME_SCHEMA.COLUMN_START_DATE', visible: true, type: 'date' },
    { key: 'toDate', value: 'WORKING_TIME_SCHEMA.COLUMN_FINISH_DATE', visible: true, type: 'date' },
    { key: 'days', value: 'WORKING_TIME_SCHEMA.COLUMN_DAYS', visible: true, type: 'number' },
    { key: 'edit', value: 'WORKING_TIME_SCHEMA.COLUMN_EDIT', visible: true, type: 'edit' },
    { key: 'delete', value: 'WORKING_TIME_SCHEMA.COLUMN_DELETE', visible: true, type: 'delete' },
  ];

  async ngOnInit() {
  }

  public isInvalid() {
    if (this.startDate) {
      this.startDate.setHours(0, 0, 0, 0);
    }

    if (this.finishDate) {
      this.finishDate.setHours(0, 0, 0, 0);
    }

    return this.daysForm.invalid || (this.currentDateType === 'range' && this.startDate > this.finishDate);
  }

  public onSetNonWorkingDate() {
    if (this.isInvalid()) {
      console.log('Not Saved');
    } else {
      const newWorkingTimeSchema = CalendarsOperations.getEmptyWorkingTimeSchema();
      if (this.currentDateType === 'exact') {
        newWorkingTimeSchema.fromDate = CalendarsOperations.getStringDate(this.onDate);
        newWorkingTimeSchema.toDate = CalendarsOperations.getStringDate(this.onDate);
      } else {
        newWorkingTimeSchema.fromDate = CalendarsOperations.getStringDate(this.startDate);
        newWorkingTimeSchema.toDate = CalendarsOperations.getStringDate(this.finishDate);
      }
      this._store.dispatch(new AddWorkingTimeSchema(newWorkingTimeSchema));
      this._resetDates();
    }
  }

  public deleteWorkingTimeSchemaRange(workingTimeSchemaRange: IWorkingTimeSchema) {
    this._store.dispatch(new DeleteWorkingTimeSchemaRange(workingTimeSchemaRange));
  }

  public getDaysBetween(from: string, to: string) {
    const start = moment(from);
    const end = moment(to);
    return end.diff(start, 'days') + 1;
  }

  public selectSchemaRange (schema: IWorkingTimeSchema) {
    this.selectedSchemaRange = schema;
    if (schema.fromDate === schema.toDate) {
      this.currentDateType = 'exact';
    } else {
      this.currentDateType = 'range';
    }
    this.onDate = moment(schema.fromDate).toDate();
    this.startDate = moment(schema.fromDate).toDate();
    this.finishDate= moment(schema.toDate).toDate();
  }

  public modifySchemaRange(schema: IWorkingTimeSchema) {
    if (this.currentDateType === 'exact') {
      schema.fromDate = CalendarsOperations.getStringDate(this.onDate);
      schema.toDate = CalendarsOperations.getStringDate(this.onDate);
    } else {
      schema.fromDate = CalendarsOperations.getStringDate(this.startDate);
      schema.toDate = CalendarsOperations.getStringDate(this.finishDate);
    }
    this._store.dispatch(new ModifyWorkingTimeSchema(schema));
    this.startDate = new Date();
    this.finishDate = new Date();
  }

  public cancelModify() {
    this.selectedSchemaRange = undefined;
    this._resetDates();
  }

  private _resetDates() {
    this.currentDateType = 'exact';
    this.startDate = new Date();
    this.finishDate = new Date();
    this.onDate = new Date();
  }
}
